import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
import { Upload, message } from "antd";
// Added getAllClients to imports
import { addNotification, getAllClients } from "../../redux/actions/authActions"; 
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { InboxOutlined } from "@ant-design/icons";

function CreateNotification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get dynamic data from Redux for the dropdowns
  const { allClients } = useSelector((state) => state.auth); 

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    target: "",
    targetList: "", // Stores specific client/team selection
    document: null
  });

  const [fileList, setFileList] = useState([]);

  // Fetch clients on load
  useEffect(() => {
    dispatch(getAllClients());
  }, [dispatch]);

  const onChange = (e) => {
    const { id, value } = e.target;

    if (id === "title") {
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [id]: lettersOnly });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleUpload = (file) => {
    setFormData({ ...formData, document: file });
    setFileList([file]); // Only keep one file
    return false; // prevent automatic upload to server
  };

  const handleRemove = () => {
    setFileList([]);
    setFormData({ ...formData, document: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.title.length > 20)
      return message.error("title should be 20 characters or less");
    
    try {
      const finalFormData = new FormData();
      finalFormData.append("title", formData.title);
      finalFormData.append("description", formData.description);
      finalFormData.append("target", formData.target);
      finalFormData.append("targetList", formData.targetList); // Send specific target selection
      
      if (formData.document) {
        finalFormData.append("document", formData.document);
      }

      await dispatch(addNotification(finalFormData));
      navigate("/notifications");
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  return (
    <div>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Create Notification" />
        <form onSubmit={handleSubmit}>
          <div className="container w-full md:w-1/2 lg:w-1/3 text-start">
            
            {/* Notification Title */}
            <div className="my-5">
              <label htmlFor="title" className="block mb-2 text-sm font-medium text-gray-900">
                Notification title
              </label>
              <input
                type="text"
                id="title"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="Enter title"
                value={formData.title}
                onChange={onChange}
                required
              />
            </div>

            {/* Description */}
            <div className="my-5">
              <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">
                Description
              </label>
              <textarea
                id="description"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="Enter Description"
                value={formData.description}
                onChange={onChange}
                required
              />
            </div>

            {/* Audience Category */}
            <div className="mb-5">
              <label htmlFor="target" className="block mb-2 text-sm font-medium text-gray-900">
                Audience
              </label>
              <select
                id="target"
                onChange={onChange}
                value={formData.target}
                required
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              >
                <option value="" disabled>Select the audience</option>
                <option value="Team">Team</option>
                <option value="Clients">Clients</option>
                <option value="Team and Clients">Team and Clients</option>
                <option value="Public">Public</option>
              </select>
            </div>

            {/* Specific Selection (The Client Type Field) */}
            {(formData.target && formData.target !== "Public") && (
              <div className="mb-5">
                <label htmlFor="targetList" className="block mb-2 text-sm font-medium text-gray-900">
                  {formData.target === "Clients" ? "Select Specific Client" : "Select Team Members"}
                </label>
                <select
                  id="targetList"
                  onChange={onChange}
                  value={formData.targetList}
                  required
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                >
                  <option value="">Select members</option>
                  <option value="Team">Team</option>
                <option value="Clients">Clients</option>
                <option value="Team and Clients">Team and Clients</option>
                <option value="Public">Public</option>
                  {/* Dynamic mapping based on target */}
                  {formData.target === "Clients" && allClients?.map(client => (
                    <option key={client._id} value={client._id}>{client.name}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Upload Document Fix */}
            <div className="mb-5">
              <label className="block mb-2 text-sm font-medium text-gray-900">
                Upload Document
              </label>
              <Upload.Dragger
                beforeUpload={handleUpload}
                fileList={fileList}
                onRemove={handleRemove}
                maxCount={1}
                listType="text"
                /* FIX: We remove 'flex items-center justify-center' when a file is present.
                   This allows the file list to render naturally below the dropzone.
                */
                className={`mb-4 border-dashed border-2 border-gray-300 rounded-lg min-h-[120px] ${
                   fileList.length === 0 ? "flex flex-col items-center justify-center" : ""
                }`}
              >
                {fileList.length === 0 && (
                  <>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined className="text-blue-500 text-3xl" />
                    </p>
                    <p className="ant-upload-text text-gray-500">
                      Select or drag the file to upload
                    </p>
                  </>
                )}
              </Upload.Dragger>
            </div>

            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Add Notification
            </button>
          </div>
        </form>
      </MainSection>
    </div>
  );
}

export default CreateNotification;